
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.285 11.796v.717c0 .253-.08.463-.238.629a.77.77 0 01-.576.249h-.815a.768.768 0 01-.575-.25.872.872 0 01-.24-.628v-6.62L2.4.948c.083-.266.224-.478.425-.638.2-.16.425-.24.673-.24h8.004c.248 0 .472.08.673.24.2.16.342.372.425.638l1.558 4.945v6.62c0 .253-.08.463-.24.629a.768.768 0 01-.574.249h-.815a.768.768 0 01-.575-.25.872.872 0 01-.24-.628v-.717H3.286zm-.212-7.697h8.854l-.708-2.234H3.78L3.073 4.1zm1.204 5.104c.307 0 .573-.126.797-.378.224-.253.336-.552.336-.898 0-.345-.112-.645-.336-.897-.224-.253-.49-.379-.797-.379-.307 0-.572.126-.797.379a1.307 1.307 0 00-.336.897c0 .346.112.645.336.898.225.252.49.378.797.378zm6.446 0c.307 0 .572-.126.797-.378.224-.253.336-.552.336-.898 0-.345-.112-.645-.336-.897-.224-.253-.49-.379-.797-.379-.307 0-.573.126-.797.379a1.307 1.307 0 00-.336.897c0 .346.112.645.336.898.224.252.49.378.797.378z"}})])
          )
        }
      }
    